var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreBlack24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45, 200, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 35,
      stroke: "rgb(0, 169, 224)",
      fill: "rgba(255, 255, 255, 0)",
      paintOrder: "stroke",
      fillRule: "nonzero"
    },
    cx: 200,
    cy: 200,
    r: 165
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.735824, 0, 0, 1.510699, 26.157015, 54.925327)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 99.139 94.941 L 83.219 163.243 L 115.058 163.243 L 99.139 94.941 Z",
    style: {
      fill: "rgb(207, 69, 31)",
      stroke: "rgb(207, 69, 31)",
      paintOrder: "stroke",
      strokeWidth: 0
    },
    transform: "matrix(-1, 0, 0, -1, 198.277, 258.183998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 99.269 27.03 L 83.349 95.332 L 115.188 95.332 L 99.269 27.03 Z",
    style: {
      fill: "rgb(207, 69, 31)",
      stroke: "rgb(207, 69, 31)",
      paintOrder: "stroke",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(256, 256, 256)",
      stroke: "rgb(256, 256, 256)"
    },
    transform: "matrix(1.010101, 0, 0, 1.034736, -438.518433, -107.838722)",
    cx: 532.82,
    cy: 195.801,
    r: 5.992
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreBlack24Dp);
export default __webpack_public_path__ + "static/media/explore_black_24dp.9a220e59e8a7a5eb703b80a0b37fe2cf.svg";
export { ForwardRef as ReactComponent };